import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

function ViewProviderProfileGallery() {
  const { providerId } = useParams();
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const res = await axios.get(`${API_BASE}/gallery/${providerId}`);
        setImages(res.data.data);
      } catch (err) {
        console.error("Failed to fetch gallery", err);
      } finally {
        setLoading(false);
      }
    };
    fetchGallery();
  }, [providerId]);
const API_BASE = process.env.REACT_APP_API_BASE;

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Gallery</h2>
      {loading ? (
        <div>Loading...</div>
      ) : images.length === 0 ? (
        <div>No images found.</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {images.map((img, index) => (
            <img key={index} src={img.url} alt={`gallery-${index}`} className="w-full rounded shadow" />
          ))}
        </div>
      )}
    </div>
  );
}

export default ViewProviderProfileGallery;
